import { render, staticRenderFns } from "./AssetClassDropdownField.vue?vue&type=template&id=4328363b"
import script from "./AssetClassDropdownField.vue?vue&type=script&lang=ts"
export * from "./AssetClassDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4328363b')) {
      api.createRecord('4328363b', component.options)
    } else {
      api.reload('4328363b', component.options)
    }
    module.hot.accept("./AssetClassDropdownField.vue?vue&type=template&id=4328363b", function () {
      api.rerender('4328363b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/AssetClassDropdownField.vue"
export default component.exports